module.exports = __webpack_public_path__ + "img/main-icn-02.f764cd6d.svg";